import styled from 'styled-components';

import { fonts, colors, metrics } from '@/theme';

export const Container = styled.div`
  display: flex;
`;

export const Button = styled.button`
  border: none;
  background: none;
  outline: none;
  cursor: pointer;
  ${fonts.getRegularText()};
  color: ${({ isActive }) => (isActive ? colors.link.active : colors.black)};
  padding: 0;
  &:first-child {
    margin-right: 15px;
  }
  @media (max-width: ${metrics.mobile}px) {
    text-transform: uppercase;
    ${fonts.getSubTitle()}
    &:first-child {
      margin-right: 30px;
    } 
  }
`;
